import { packageBandModeOneOf, PACKAGE_BAND_DEFAULT } from '../../utils/pricing'

export const _resourcePricingSlotClass = {
  displayName: { type: 'string', title: 'Hinnoitteluosan julkaisunimi' },
  days: {
    type: "array",
    title: "Päivät",
    items: {
      type: "number",
      oneOf: [
        { const: 1, title: 'Maanantai' },
        { const: 2, title: 'Tiistai' },
        { const: 3, title: 'Keskiviikko' },
        { const: 4, title: 'Torstai' },
        { const: 5, title: 'Perjantai' },
        { const: 6, title: 'Lauantai' },
        { const: 7, title: 'Sunnuntai' },
      ],
    },
    "uniqueItems": true
  },
  starttime: {
    type: 'string',
    title: 'Alkuaika'
  },
  endtime: {
    type: 'string',
    title: 'Loppuaika'
  },
  price: {
    type: 'number',
    title: 'Hinta'
  },
  nonlinearpricing: {
    type: 'boolean',
    title: 'Käytä epälineaarista hinnoittelua'
  },
  // prices: {
  //   type: 'array',
  //   title: 'Hinnat',
  //   items: [
  //     {
  //       title: '30 min',
  //       type: 'number',
  //       default: 0
  //     },
  //     {
  //       title: '1 h',
  //       type: 'number',
  //       default: 0
  //     },
  //     {
  //       title: '1,5 h',
  //       type: 'number',
  //       default: 0
  //     },
  //     {
  //       title: '2 h',
  //       type: 'number',
  //       default: 0
  //     },
  //     {
  //       title: '2,5 h',
  //       type: 'number',
  //       default: 0
  //     },
  //     {
  //       title: '3 h',
  //       type: 'number',
  //       default: 0
  //     },
  //   ]
  // },
  pricingunit: {
    type: 'string',
    title: 'Hinnan yksikkö',
    oneOf: [
      { const: 'h', title: 'tunti' },
    ],
  },
}

export const _resourcePricingSlotClassDeps = {
  nonlinearpricing: {
    oneOf: [
      {
        properties: {
          nonlinearpricing: {
            enum: [true],
          },
          prices: {
            type: 'array',
            title: 'Hinnat',
            items: [
              { title: '30 min', type: 'number', default: 0 },
              { title: '1 h', type: 'number', default: 0 },
              { title: '1,5 h', type: 'number', default: 0 },
              { title: '2 h', type: 'number', default: 0 },
              { title: '2,5 h', type: 'number', default: 0 },
              { title: '3 h', type: 'number', default: 0 },
            ],
          },
        },
      }
    ],
  }
}


export const _resourcePricingSlotUISchema = {
  days: {
    'ui:widget':'checkboxes'
  },
  starttime: {
    'ui:widget':'timeWidget'
  },
  endtime: {
    'ui:widget':'timeWidget'
  },
  prices: {
    items: [
      { 'ui:title': '30 min' },
      { 'ui:title': '1 h' },
      { 'ui:title': '1,5 h' },
      { 'ui:title': '2 h' },
      { 'ui:title': '2,5 h' },
      { 'ui:title': '3 h' },
    ],
  },
}

export const _resourcePricingClass = {
  name: { type: 'string', title: 'Hinnoittelun nimi' },
  active: { type: 'boolean', title: 'Active' },
  priority: { type: 'number', title: 'Prioriteetti' },
  validstart: { type: 'string', format: 'date', title: 'Alkupäivä' },
  validend: { type: 'string', format: 'date', title: 'Loppupäivä' },
  zeroprice: {
    type: 'boolean',
    title: 'Valitse tämä mikäli haluat hyväksyä nollahintaisia hinnoitteluosioita tähän hinnastoon. Muuten 0€ hintaiset hinnoitteluosiot ohitetaan.',
  },
  // Koskee vain pakettihinnoiteltuja (nonlinearpricing) hinnoitteluosioita ja vain silloin
  // kun varaus jakautuu kahdelle osiolle: pakettiosio leikkaa varauksen muttei kata sitä.
  // Valinnan puuttuminen = nykyinen käyttäytyminen. Ks. utils/pricing.js.
  packagebandmode: {
    type: 'string',
    title: 'Epälineaarinen hinnoittelu: Vuoronhinta kun jakautuu kahdelle hinta-alueelle',
    // 'default' on sentinel, ei tallennettava arvo: firebase.js poistaa kentän kun se on
    // valittuna. rjsf esivalitsee oneOf-listan ensimmäisen constin, joten oletusvalinnan on
    // pakko olla listassa ensimmäisenä - muuten hinnaston avaaminen ja tallentaminen
    // muuttaisi hinnoittelua ilman että kukaan valitsi mitään. Ks. utils/pricing.js.
    default: PACKAGE_BAND_DEFAULT,
    oneOf: packageBandModeOneOf(),
  },
  resources: {
    type: "array",
    title: "Resurssit",
    items: {
      type: "string",
      oneOf: [],
    },
    "uniqueItems": true
  },
}


export const _resourcePricingUISchema = {
  resources: {
    'ui:widget':'checkboxes'
  },
  priority: {
    'ui:help': 'Pienempi numero on korkeampi prioriteetti'
  },
  packagebandmode: {
    // ui:emptyValue varmistaa että mahdollinen tyhjä valinta antaa tyhjän merkkijonon eikä
    // undefinediä: Firestore v8 kaatuu undefinediin, ja firebase.js osaa poistaa tyhjän.
    // Schemaan asetettu default estää rjsf:n oman tyhjän placeholder-rivin, joten tyhjää
    // valintaa ei pitäisi näkyä lainkaan.
    'ui:emptyValue': '',
    'ui:help':
      'Vaikuttaa vain pakettihinnoiteltuihin (epälineaarisiin) hinnoitteluosioihin, ja vain kun ' +
      'varaus ylittää osion rajan niin ettei mikään paketti kata koko varausta. Oletuksena varaus ' +
      'maksaa kahden lyhyemmän paketin summan. "Ohita" tarkoittaa että koko tämä hinnasto jää ' +
      'tuottamatta hintaa, jolloin seuraava prioriteetti yritetään.',
  }
}

